import CollaboratorForm from './ChangePasswordForm';

export default CollaboratorForm;
